import { Link } from 'react-router-dom';

export default function PublicBreadcrumbs({ items = [] }) {
  return <nav aria-label="Breadcrumb" className="text-sm text-text-secondary">
    <ol className="flex flex-wrap items-center gap-2">
      {items.map((item, index) => <li key={`${index}:${item.name}`} className="flex items-center gap-2">
        {index > 0 ? <span aria-hidden="true">/</span> : null}
        {item.href ? <Link to={item.href} className="font-medium text-primary hover:underline">{item.name}</Link> : <span aria-current="page">{item.name}</span>}
      </li>)}
    </ol>
  </nav>;
}
